<template>
  <div class="register">
    <Register />
  </div>
</template>

<script>
// @ is an alias to /src
import Register from "@/components/Register_component.vue";

export default {
  name: "Registro",
  components: {
    Register,
  },
};
</script>
